var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-close_button"},[_c('div',{staticClass:"mc-close_button-body",style:({ 'background-color': _vm.getColor() })}),_c('div',{staticClass:"mc-close_button-shadow"})])}
var staticRenderFns = []

export { render, staticRenderFns }